import { API_BASE, authHeaders } from "./client";

export async function fetchStoreLocations() {
  const res = await fetch(`${API_BASE}/store-locations`, { headers: authHeaders() });
  if (!res.ok) return null;
  return res.json();
}
